export const alertMixin = {
    methods: {
        successAlert(title, subTitle) {
            this.$vs.notify({
                title: title,
                text: subTitle,
                color: "success",
                icon: "check_box"
            });
        },
        successAlertWithPromise(title, subTitle) {
            return new Promise((resolve, reject) => {
                this.$vs.notify({
                    title: title,
                    text: subTitle,
                    color: "success",
                    icon: "check_box"
                });
            });
        },
        errorAlert(title, subTitle) {
            this.$vs.notify({
                title: title,
                text: subTitle,
                color: "warning",
                icon: "error",
                htlm: true,
                time:8000,

            });
        },
        confirmAlert(title, msg) {
            return new Promise((resolve, reject) => {
                this.$vs.dialog({
                    type: 'confirm',
                    color: "warning",
                    title: title,
                    text: msg,
                    accept: resolve
                })
            }); 
        },
        normarAlert(title, msg) {
            return new Promise((resolve, reject) => {
                this.$vs.dialog({ 
                    color: "success",
                    title: title,
                    text: msg,
                    buttonAccept: false,
                    accept: resolve
                })
            }); 
        },
        msgLoading() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {

                    resolve('dddd');
                }, 1000)
            })
 
        },
        decodeSuccessFromAxios(response, msg) {
            if (response.status == 200 || response.status == 201) {
                this.successAlert("Success", msg);
            } else if (response.code == 422) {
                this.errorAlert("Failed", "Error code: " + response.error);
            } else {
                this.errorAlert("Failed", "Error code: " + response.status);
            }
        },
        decodeErrorFromAxios(error) {
            return new Promise((resolve, reject) => {
                if (error.response) {
                    var errorMsg = "";
                  
                    if (Object.prototype.toString.call(error.response.data.error) === '[object Object]') {
                        for (var e in error.response.data.error) {
                            errorMsg = errorMsg + "<br>" + error.response.data.error[e][0];
                        }
                    } else {
                        errorMsg = error.response.data.error;
                    }
                    this.errorAlert("Failed", errorMsg);
                } else if (error.request) {
                    
                    this.errorAlert("Failed request", error.request);
                    errorMsg = error.request
                } else {
                    this.errorAlert("General Error", error.message);
                    errorMsg = error.message
                }

                resolve(errorMsg);
            });

        }
    }
};